<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title"><i class="fa fa-exchange-alt"></i>&nbsp; Transactions</h4>
                                <h5 class="card-subtitle">Retrieve transactions for a transactions user for the last <strong>30</strong> days</h5>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table v-middle">
                                <thead>
                                <tr class="bg-light">
                                    <th class="border-top-0"><h6>Transaction ID</h6></th>
                                    <th class="border-top-0"><h6>Name</h6></th>
                                    <th class="border-top-0"><h6>Type</h6></th>
                                    <th class="border-top-0"><h6>Narration/Ref/Cheque No</h6></th>
                                    <th class="border-top-0"><h6>Debit/Credit</h6></th>
                                    <th class="border-top-0"><h6>Date</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr :class="{ 'outwards' : Number(transaction.amount) >= 0, 'inwards' : Number(transaction.amount) < 0}" v-bind:key="index"
                                    v-for="(transaction, index) in transactions">
                                    <td>{{transaction.transaction_id | truncate(25, '...')}}</td>
                                    <td>{{transaction.name}}</td>
                                    <td>{{transaction.transaction_type}}</td>
                                    <td v-if="transaction.payment_meta.payee">{{transaction.payment_meta.payee}}</td>
                                    <td v-if="!transaction.payment_meta.payee">N/A</td>
                                    <td>{{transaction.amount}} {{transaction.iso_currency_code}}</td>
                                    <td>{{transaction.date}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Transactions",
        props: ['accountid'],
        data() {
            return {
                transactions: []
            };
        },
        mounted() {
            this.getTransactions();
        },
        methods: {
            async getTransactions() {
                $(".preloader").fadeIn();
                let reply = await this.$http.get("/banking/transactions", {
                    params: {
                        account_id: this.accountid
                    }
                });
                $(".preloader").fadeOut();
                this.transactions = reply.data;

            }
        }
    }
</script>

<style scoped>
    .inwards {
        background-color: #ffefef;
    }

    .outwards {
        background-color: #efffef;
    }
</style>
